import React from 'react';
import { Link } from 'react-router-dom'
import moment from 'moment'
import { Button } from 'reactstrap';

export default class BookingService extends React.Component {
  markCompleted = () => {
    this.setState({ completing: true });
    this.props.bookingService.update({
      parent: this.props.bookingService.booking,
      markedcompletebyactor: this.props.user
    }).then(this.props.onComplete, () => {
      // error
      this.setState({ completing: false });
    });
  };

  render() {
    var bookingService = this.props.bookingService;

    if (this.state && this.state.completing) {
      // MS - not sure what goes here.
    }

    if (!this.props.onComplete) {
      var button = <Link className='btn btn-primary' to={`/submitinvoice/${bookingService.booking.id}/${bookingService.id}`}>Submit invoice</Link>
    } else {
      button = <Button onClick={ this.markCompleted }>Mark completed</Button>;
    }

    return (
      <tr>
        <td>{ moment(bookingService.booking.fromdate).format('ddd D MMM YYYY') }</td>
        <td>{ bookingService.booking.property.name }</td>
        <td>
          <div>{ bookingService.service.name }</div>
          <div>{ bookingService.booking.getPartySizeString() || `${bookingService.booking.guesttype === 'None' ? 'Agency' : bookingService.booking.guesttype} booking` }</div>
        </td>
        <td>{ button }</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/BookingService.js